var render = function () {
var _obj, _obj$1;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',{staticClass:"pagination"},[_c('li',[(!_vm.disabled)?_c('router-link',{staticClass:"pre",attrs:{"to":{
        name: _vm.pathName,
        params: _vm.urlParams,
        query: Object.assign(( _obj = {}, _obj[_vm.pageParamKey] = Math.max(1, _vm.selected - 1), _obj ),
          _vm.queryParams)
      }}},[_c('span',[_vm._v("«")])]):_c('div',{staticClass:"disabled-link pre"},[_c('span',[_vm._v("«")])])],1),_vm._l((_vm.pages),function(page,index){
      var _obj;
return _c('li',{key:index},[(page.breakView)?_c('div',{staticClass:"break-view"},[_c('span',[_vm._v("…")])]):(!page.disabled)?_c('router-link',{class:{ active: page.isSelected },attrs:{"to":{
        name: _vm.pathName,
        query: Object.assign(( _obj = {}, _obj[_vm.pageParamKey] = page.content, _obj ), _vm.queryParams)
      }}},[_c('span',[_vm._v(_vm._s(page.content))])]):_c('div',{class:{ active: page.isSelected, 'disabled-link': true }},[_c('span',[_vm._v(_vm._s(page.content))])])],1)}),_c('li',[(!_vm.disabled)?_c('router-link',{staticClass:"next",attrs:{"to":{
        name: _vm.pathName,
        params: _vm.urlParams,
        query: Object.assign(( _obj$1 = {}, _obj$1[_vm.pageParamKey] = Math.min(_vm.pageCount, _vm.selected + 1), _obj$1 ),
          _vm.queryParams)
      }}},[_c('span',[_vm._v("»")])]):_c('div',{staticClass:"disabled-link next"},[_c('span',[_vm._v("»")])])],1)],2)}
var staticRenderFns = []

export { render, staticRenderFns }